/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';
import * as actions from './actions';
import * as actionsAuth from '../auth/actions';
import * as actionsOrder from '../order/actions';
import * as actionsParameter from './../parameter/actions';
import { checkoutActionTypes } from './types';
import api from '../../../services/api';
import { UserAddresses } from '../auth/types';
import httpsAdapter from '../../../adapters/https/https-adapter';
import { config } from '../../../config';
import { StoreState } from '../../createStore';

const erroMessage = 'Ops! ocorreu um erro no servidor';

interface IErrorResponse {
  status: number;
  code: string;
  message: string;
  errors: string;
}

const getMessageError = (props: IErrorResponse) => {
  const tableMessage: Record<string, string> = {
    'E000004': 'main.messages_toast.error_cart.error_E000004'
  }

  return tableMessage[props.code] || erroMessage;
}

export function* uploadCheckoutRequest() {
  try {
    const { parameter }: StoreState = yield select();

    let data;
    if (config.isOldCard) {
      const { data: dataReponse } = yield call(api.get, `cart`);
      data = dataReponse;
    } else {
      const { data: dataReponse } = yield call(api.patch, `cart/update-prices-store/${parameter.multistoreSelected.store_id}`, {});
      data = dataReponse;
    }

    if (data.status === 200) yield put(actions.checkoutSucess(data.data));
    else {
      yield put(actions.checkoutFailure());
    }

  } catch (err) {
    yield put(actions.checkoutFailure());
    if (err && typeof err === 'object' && 'response' in err && err.response && 'status' in err.response) {
      if (err.response.status === 401) {
        yield put(actionsAuth.signOut());
      } else if (err.response.status >= 500 && err.response.status <= 599) {
        yield put(actions.voidedSale());
        yield put(actionsParameter.setMessageToast({ type: 'error', message: erroMessage }));
      }
    }
  }
}

export function* getCheckoutRequest() {
  try {
    const { data } = yield call(api.get, `cart`);
    if (data.status === 200) yield put(actions.checkoutSucess(data.data));
    else {
      yield put(actions.checkoutFailure());
    }
  } catch (err) {
    yield put(actions.checkoutFailure());
    if (err && typeof err === 'object' && 'response' in err && err.response && 'status' in err.response) {
      if (err.response.status === 401) {
        yield put(actionsAuth.signOut());
      } else if (err.response.status >= 500 && err.response.status <= 599) {
        yield put(actions.voidedSale());
        yield put(actionsParameter.setMessageToast({ type: 'error', message: erroMessage }));
      }
    }
  }
}

export function* checkoutAddPluRequest({
  payload,
}: ActionType<typeof actions.checkoutAddPlu>) {
  try {
    const { product_id, sellerId, serviceId, cartProduct, observation } = payload;
    const { parameter }: StoreState = yield select();

    let sendItem = [];

    if (cartProduct && cartProduct.length > 0) {
      sendItem = cartProduct;
    } else {
      sendItem.push({
        product_id: `${product_id}`,
        quantity: '1',
        ...(sellerId ? { [`${sellerId}`]: `${sellerId}` } : {}),
        ...(serviceId ? { service_id: `${serviceId}` } : {}),
        ...(observation ? { observation } : {})
      });
    }

    let body;
    if (config.isOldCard) {
      body = sendItem;
    } else {
      body = {
        store_id: parameter.multistoreSelected.store_id,
        items: sendItem,
      };
    }

    const { data } = yield call(api.post, `cart/add`, body);

    yield put(actions.checkoutSucess(data.data));
    yield put(actionsParameter.setMessageToast({ type: 'success', messageTranslationId: 'main.messages_toast.add_card' }));
  } catch (err) {
    yield put(actions.checkoutFailure());
    if (err.response && err.response.status === 401) {
      // Tratar erro de autenticação se necessário
      yield put(actionsAuth.signOut());
    }

    if (err.response && err.response.data.code) {
      yield put(actionsParameter.setMessageToast({ type: 'error', messageTranslationId: getMessageError(err.response.data) }));
    }
  }
}

export function* updatePluQtyCheckoutRequest({
  payload,
}: ActionType<typeof actions.updatePluQtyCheckout>) {
  try {
    const { cart_item_id, qty, observation } = payload;
    const { parameter }: StoreState = yield select();

    const quantity = qty;

    let body;
    if (config.isOldCard) {
      body = {
        qty: {
          [cart_item_id]: quantity,
        },
        ...(observation ? {
          observation: {
            [cart_item_id]: observation
          }
        } : {})
      }
    } else {
      body = {
        store_id: parameter.multistoreSelected.store_id,
        items: [
          {
            cart_item_id,
            quantity,
            ...(observation ? { observation } : {})
          }
        ]
      };
    }

    const { data } = yield call(
      api.post,
      `cart/update`,
      body,
    );

    yield put(actions.checkoutSucess(data.data));
    yield put(actionsParameter.setMessageToast({ type: 'success', messageTranslationId: 'main.messages_toast.update_card' }));
  } catch (err) {
    if (err.response && err.response.status === 401) {
      // Tratar erro de autenticação se necessário
      yield put(actionsAuth.signOut());
    } else {
      yield put(actions.checkoutFailure());
    }
  }
}

export function* removeProductCheckout({
  payload,
}: ActionType<typeof actions.checkoutRemovePlu>) {
  try {
    //konsole.log('removeProductCheckout: ', payload);
    const { cart_item_id } = payload;

    //konsole.log('removeProductCheckout: ID', id, 'CART ID', cart_item_id);
    const { data } = yield call(
      api.get,
      `cart/remove-item/${cart_item_id}`,
    );

    if (data.data && data.data === 'Não ha mais produtos no carrinho') {
      yield put(actions.checkoutFailure());
      return;
    }

    //konsole.log('removeProductCheckout->dataRep: ', dataRep);
    yield put(actions.checkoutSucess(data.data));
    yield put(actionsParameter.setMessageToast({ type: 'success', messageTranslationId: 'main.messages_toast.remove_card' }));
  } catch (err) {
    yield put(actions.checkoutFailure());
    try {
      // @ts-ignore
      if (err.response && err.response.status === 401) {
        yield put(actionsAuth.signOut());
        // @ts-ignore
      } else if (err.response && err.response.status >= 500 && err.response.status <= 599) {
        yield put(actionsParameter.setMessageToast({ type: 'error', message: erroMessage }));
      }
    } catch (_) {
      // Ignora erros de acesso a propriedades
    }
  }
}

export function* closeSale({ payload }: ActionType<typeof actions.closeSale>) {
  try {
    const method = payload.user.methods?.find(method => method.selected);
    if (method === undefined) {
      yield put(
        actions.closeSaleFailure({
          code: '1',
          data: '',
          message:
            'Nenhuma forma de pagamento selecionada, selecione uma forma de pagamento para finalizar a compra!!!',
        }),
      );
      return;
    }

    const paymentSitefData = {
      payment: {
        method: method.method,
        card_number: method.card_number,
        card_last_four: method.card_number,
        card_brand: method.card_brand,
        full_name: method.full_name,
        //customer_doc: '31010351800',
        expiry_date: method.expiry_date,
      },
    };

    const {
      data: {
        data: { order },
      },
    } = yield call(api.post, `cart/save-order`, {
      email: payload.user.data.email,
    });

    //############### AQUI VAMOS COLOCAR A CHAMADA DO SITEF ####### //
    yield call(
      api.post,
      `order/update-payment/${order.order_id}`,
      paymentSitefData,
    );

    yield put(actions.closeSaleSucess(order));
  } catch (error) {
    if (error.response) {
      yield put(actions.closeSaleFailure(error.response.data));
    } else if (error.response.status >= 500 && error.response.status <= 599) {
      yield put(actionsParameter.setMessageToast({ type: 'error', message: erroMessage }));
    }
  }
}

export function* voidedSale() {
  try {
    //konsole.log('voidedSale: ', payload);
    yield call(api.get, `cart/empty`);
    //konsole.log('voidedSale: data', data);
    yield put(actions.voidedSaleSucess());
  } catch (err) {
    yield put(actions.checkoutFailure());
  }
}

export function* orderByIdRemakeRequest({
  payload,
}: ActionType<typeof actions.orderByIDRemake>) {
  try {
    //konsole.log('orderByIdRemakeRequest:', type, payload);
    const { data } = yield call(api.get, `order/${payload.order_id}`);

    //konsole.log('orderByIdRemakeRequest: data', data);

    yield put(actions.orderByIDRemakeSuccess(data.data));
  } catch (err) {
    //konsole.log('orderByIdRemakeRequest: err', err);
    if (err && typeof err === 'object' && 'response' in err && err.response && 'status' in err.response) {
      if (err.response.status >= 500 && err.response.status <= 599) {
        yield put(actionsParameter.setMessageToast({ type: 'error', message: erroMessage }));
      }
    }
  }
}

export function* sendRequestNew({
  payload,
}: ActionType<typeof actions.sendRequestNew>) {
  try {
    const { auth, checkout }: StoreState = yield select();
    yield put(actionsOrder.orderClear());

    let shipping_method = null;
    //#### ENVIADO O ENDERECO ########################//
    if (payload.store) {
      shipping_method = 'store';
    } else if (payload.locker) {
      shipping_method = 'locker';
    }

    const addressSel = {
      // ...payload.address ? payload.address : undefined,
      shipping_method: shipping_method ? shipping_method : payload.shippingMethod,
      address_id: payload.address !== undefined ? payload.address.id : 0,
      ...(payload.store !== undefined ? {
        store_id: payload.store.store_id,
      } : {}),
      ...(payload.locker !== undefined ? {
        locker_id: payload.locker.id,
      } : {}),
      ...(payload.shippingDate !== undefined ? {
        shipping_date: payload.shippingDate
      } : {}),
      ...(checkout.methodPaymentSelected.others.length > 0 ?
        {
          method: checkout.methodPaymentSelected.others[0].method
        }
        : {}
      ),
      ...(checkout.methodPaymentSelected.cashOnDelivery.length > 0 ?
        {
          method: checkout.methodPaymentSelected.cashOnDelivery[0].method
        }
        : {}
      ),
      ...(checkout.methodPaymentSelected.cards.length > 0 ?
        {
          method: checkout.methodPaymentSelected.cards[0].method
        }
        : {}
      ),
      // address_name: payload.store !== undefined ? 'store' : payload.address?.address_name,
      // postcode: payload.store !== undefined ? payload.store.zip_code : payload.address?.postcode,
      // address_type: 'customer',
    };
    //konsole.log('sendRequestNew()->addressSel: ', addressSel)
    yield call(
      api.post,
      `cart/save-address`,
      addressSel,
    );
    //konsole.log('sendRequestNew()->checkoutAddressData: ', checkoutAddressData)

    //#### CRIANDO ORDER ########################//
    const { data } = yield call(
      api.post,
      `cart/save-order`,
      {
        email: payload.email,
        ...(checkout.methodPaymentSelected.others.length > 0 ?
        {
          payment_method: checkout.methodPaymentSelected.others[0].method
        }
        : {}
      ),
      ...(checkout.methodPaymentSelected.cashOnDelivery.length > 0 ?
        {
          payment_method: checkout.methodPaymentSelected.cashOnDelivery[0].method
        }
        : {}
      ),
      ...(checkout.methodPaymentSelected.cards.length > 0 ?
        {
          payment_method: checkout.methodPaymentSelected.cards[0].method
        }
        : {}
      )
      },
    );

    //konsole.log('sendRequestNew()->checkoutOrderData: ', data.data.order)
    const shipping = payload.checkout?.shipping || 0;
    const amountPay = Number(payload.checkout?.grand_total) + shipping;

    // if (payload.checkout?.total && payload.address?.shipping?.price)
    // amountPay = payload.checkout?.total + payload.address?.shipping?.price
    if (data.data.order) {
      if (payload.method) payload.method.id = undefined;

      let paymentSitefData: { payment: Record<string, string | number | undefined> } = {
        payment: {}
      };

      if (config.isNewLayoutChosePayment) {
        paymentSitefData = {
          payment: {
            amount: amountPay,
            customer_doc: auth.user.data.customer_id,
            ...(checkout.methodPaymentSelected.others.length > 0 ?
              checkout.methodPaymentSelected.others[0]
              : {}
            ),
            ...(checkout.methodPaymentSelected.cashOnDelivery.length > 0 ?
              checkout.methodPaymentSelected.cashOnDelivery[0]
              : {}
            ),
          }
        }
        if (checkout.methodPaymentSelected.cards.length > 0) {
          const { id, ...card } = checkout.methodPaymentSelected.cards[0];
          paymentSitefData.payment = {
            ...paymentSitefData.payment,
            ...card,
            security_code: payload.security_code,
            customer_doc: payload.method?.customer_doc || auth.user.data.customer_id,
          }
        }
      } else {
        paymentSitefData = {
          payment: {
            amount: amountPay,
            method: 'cashondelivery'
          },
        };

        if (!payload.payOnDelivery) {
          paymentSitefData = {
            payment: {
              ...paymentSitefData.payment,
              ...payload.method,
              security_code: payload.security_code,
              method: payload.method?.method,
              customer_doc: payload.method?.customer_doc || auth.user.data.customer_id,
            }
          }
        }
      }

      const { data: checkoutUpdatePaymentData } = yield call(
        [httpsAdapter, httpsAdapter.request],
        {
          data: paymentSitefData,
          isEncrypt: config.isEncryptData,
          method: 'POST',
          path: `api/order/update-payment/${data.data.order.order_id}`,
          headers: {
            'info-parameter': `w=${payload.windowsConfig.width}&h=${payload.windowsConfig.height}&c=${payload.windowsConfig.colorDepth}&js=true&jv=false&tz=${new Date().getTimezoneOffset().toString()}&ch=2`
          }
        }
      );

      yield put(
        actions.orderCheckoutResponse(
          checkoutUpdatePaymentData.data
        ),
      );
      yield put(
        actionsParameter.methodSetSelectedClear()
      )
    }
    //konsole.log('sendRequestNew()->checkoutUpdatePaymentData: ', checkoutUpdatePaymentData)
    yield put(actions.clearSale());
  } catch (err) {
    //konsole.log('sendRequestNew: err', err);
    yield put(
      actions.closeSaleFailure({
        code: '1',
        data: '',
        message: 'Erro ao processar o pedido',
      }),
    );
    if (err && typeof err === 'object' && 'response' in err && err.response && 'status' in err.response) {
      if (err.response && err.response.status === 401) {
        // Tratar erro de autenticação se necessário
        yield put(actionsAuth.signOut());
      } else if (err.response.status === 422) {
        yield put(actionsParameter.setMessageToast({ type: 'error', message: (err as any).response.data.data }));
      } else if (err.response.status >= 500 && err.response.status <= 599) {
        yield put(actions.voidedSale());
        yield put(actionsParameter.setMessageToast({ type: 'error', message: erroMessage }));
      }
    }
  }
}

export function* verifyCustomerCardIsExistRequest({
  payload,
}: ActionType<typeof actions.verifyCustomerCardIsExist>) {
  try {
    //konsole.log('orderByIdRemakeRequest:', type, payload);
    const { data } = yield call(api.post, `customer/verify`, {
      data: payload.cpfOrEmail,
    });
    if (data.message === 'Identificador disponível') {
      yield put(
        actions.closeSaleFailure({
          code: '200',
          data: '',
          message: 'Cliente não encontrado, faça seu cadastro',
        }),
      );
      return;
    }
    yield put(
      actions.verifyCustomerCardIsExistSucess({
        data: data.data,
        message: payload.message,
      }),
    );
  } catch (err) {
    //konsole.log('orderByIdRemakeRequest: err', err);
    yield put(
      actions.closeSaleFailure({
        code: '200',
        data: '',
        message: 'Ops! ocorreu um erro',
      }),
    );
    if (err && typeof err === 'object' && 'response' in err && err.response && 'status' in err.response) {
      if (err.response && err.response.status === 401) {
        // Tratar erro de autenticação se necessário
        yield put(actionsAuth.signOut());
      }
      else if (err.response.status >= 500 && err.response.status <= 599) {
        yield put(actionsParameter.setMessageToast({ type: 'error', message: erroMessage }));
      }
    }
  }
}

export function* createOrUpdateAddressCustomerCardRequest({
  payload,
}: ActionType<typeof actions.createOrUpdateAddressCustomerCard>) {
  try {
    //konsole.log('addressesCreatedOrUpdateRequest()->payload: ', payload)
    const addressRequest: UserAddresses = {
      address_id: payload.addresse.id ? payload.addresse.id.toString() : '',
      name: payload.addresse.address_name,
      country: 'BR',
      country_name: 'Brasil',
      ...payload.addresse,
    };

    //konsole.log('addressesCreatedOrUpdateRequest->addressRequest: ', addressRequest);
    if (addressRequest.id > 0) {
      // Vamos atualizar
      yield call(api.put, `addresses/${addressRequest.id}`, addressRequest);
    } else {
      // Vamos criar um novo endereço
      yield call(api.post, `addresses/createId`, {
        ...addressRequest,
        id: `${payload.idCustomerCard}`,
        default_address: true,
      });
      yield put(actions.createOrUpdateAddressCustomerCardSucess());
    }
    yield put(
      actions.verifyCustomerCardIsExist(payload.customer_id, payload.message),
    );
  } catch (err) {
    //konsole.log('addressesCreatedOrUpdateRequest->err: ', err);
    if (err && typeof err === 'object' && 'response' in err && err.response && 'status' in err.response) {
      if (err.response.status === 401) {
        yield put(actionsAuth.signOut());
      } else if (err.response.status >= 500 && err.response.status <= 599) {
        yield put(actionsParameter.setMessageToast({ type: 'error', message: erroMessage }));
      }
    }
    yield put(actions.clearLoading());
  }
}

export function* selectedAddressCustomerCardRequest({
  payload,
}: ActionType<typeof actions.selectedAddressCustomerCard>) {
  try {
    //konsole.log('orderByIdRemakeRequest:', type, payload);
    yield call(
      api.post,
      `/addresses/selectedId`,
      {
        id: payload.idCustomerCard,
        address_id: payload.address_id,
      },
    );
    yield put(
      actions.verifyCustomerCardIsExist(payload.customer_id, payload.message),
    );
  } catch (err) {
    //konsole.log('orderByIdRemakeRequest: err', err);
    if (err && typeof err === 'object' && 'response' in err && err.response && 'status' in err.response) {
      if (err.response.status === 401) {
        yield put(actionsAuth.signOut());
      } else if (err.response.status >= 500 && err.response.status <= 599) {
        yield put(actionsParameter.setMessageToast({ type: 'error', message: erroMessage }));
      }
    }
    yield put(actions.clearLoading());
  }
}

export function* updateCustomerCardRequest({
  payload,
}: ActionType<typeof actions.updateCustomerCard>) {
  try {
    //konsole.log('orderByIdRemakeRequest:', type, payload);
    yield call(api.put, `customer/profile/${payload.idCustomerCard}`, {
      email: payload.customer.email,
      first_name: payload.customer.first_name,
      last_name: payload.customer.last_name,
      date_of_birth: `${payload.customer.date_of_birth?.slice(
        4,
        9,
      )}-${payload.customer.date_of_birth?.slice(
        2,
        4,
      )}-${payload.customer.date_of_birth?.slice(0, 2)}`,
      customer_id: payload.customer.customer_id,
      phone: payload.customer.phone,
    });
    if (payload.customer.customer_id)
      yield put(
        actions.verifyCustomerCardIsExist(
          payload.customer.customer_id,
          payload.message,
        ),
      );
  } catch (err) {
    //konsole.log('orderByIdRemakeRequest: err', err);
    if (err && typeof err === 'object' && 'response' in err && err.response && 'status' in err.response) {
      if (err.response.status >= 500 && err.response.status <= 599) {
        yield put(actionsParameter.setMessageToast({ type: 'error', message: erroMessage }));
      }
    }
    yield put(actions.clearLoading());
  }
}

export function* removeAddressCustomerCardRequest({
  payload,
}: ActionType<typeof actions.removeAddressCustomerCard>) {
  try {
    yield call(api.delete, `addresses/${payload.addresse.id}`);

    yield put(actions.removeAddressCustomerCardSucess());
    yield put(
      actions.verifyCustomerCardIsExist(payload.customer_id, payload.message),
    );
  } catch (err) {
    //konsole.log('addressesCreatedOrUpdateRequest->err: ', err);
    if (err && typeof err === 'object' && 'response' in err && err.response && 'status' in err.response) {
      if (err.response.status === 401) {
        yield put(actionsAuth.signOut());
      } else if (err.response.status >= 500 && err.response.status <= 599) {
        yield put(actionsParameter.setMessageToast({ type: 'error', message: erroMessage }));
      }
    }
    yield put(actions.clearLoading());
  }
}

export function* applyCouponRequest({
  payload,
}: ActionType<typeof actions.applyCoupon>) {
  try {
    const { data } = yield call(
      api.post,
      `cart/apply-coupon`,
      {
        code: payload.coupon,
      }
    );

    //konsole.log('removeProductCheckout->dataRep: ', dataRep);
    yield put(actions.checkoutSucess(data.data.cart));
  } catch (err) {
    //konsole.log('addressesCreatedOrUpdateRequest->err: ', err);
    if (err && typeof err === 'object' && 'response' in err && err.response && 'status' in err.response) {
      if (err.response.status === 401) {
        yield put(actionsAuth.signOut());
      } else if (err.response.status === 422) {
        yield put(
          actionsParameter.setMessageToast({
            type: 'error', message: payload.messageError
          }),
        );
      } else if (err.response.status >= 500 && err.response.status <= 599) {
        yield put(actionsParameter.setMessageToast({ type: 'error', message: erroMessage }));
      }
    }
    yield put(actions.clearLoading());
  }
}

export function* checkPaymentRequest({
  payload,
}: ActionType<typeof actions.checkPaymentRequest>) {
  try {
    const { data } = yield call(api.get, `order/confirm-payment/${payload.transactionId}`);

    if (payload.isOrderPage) {
      yield put(actionsOrder.orderSucess(data.data.order));
    }
    yield put(actions.orderCheckoutResponse(data.data));
  } catch (err) {
    if (err && typeof err === 'object' && 'response' in err && err.response && 'status' in err.response) {
      if (err.response.status === 401) {
        yield put(actionsAuth.signOut());
      } else if (err.response.status >= 500 && err.response.status <= 599) {
        yield put(actionsParameter.setMessageToast({ type: 'error', message: erroMessage }));
      }
    }
  }
}

export default all([
  takeLatest(checkoutActionTypes.UPLOAD_CHECKOUT, uploadCheckoutRequest),
  takeLatest(checkoutActionTypes.GET_CHECKOUT, getCheckoutRequest),
  takeLatest(checkoutActionTypes.ADD_PLU_CHECKOUT, checkoutAddPluRequest),
  takeLatest(
    checkoutActionTypes.UPDATE_PLU_QTY_CHECKOUT,
    updatePluQtyCheckoutRequest,
  ),
  takeLatest(checkoutActionTypes.REMOVE_PLU_CHECKOUT, removeProductCheckout),
  takeLatest(checkoutActionTypes.CLOSE_SALE, closeSale),
  takeLatest(checkoutActionTypes.VOIDED_SALE, voidedSale),
  takeLatest(
    checkoutActionTypes.ORDER_ID_REMAKE_REQUEST,
    orderByIdRemakeRequest,
  ),
  takeLatest(checkoutActionTypes.SEND_REQUEST_NEW, sendRequestNew),
  takeLatest(
    checkoutActionTypes.VERIFY_CUSTOMER_CARD_IS_EXIST,
    verifyCustomerCardIsExistRequest,
  ),
  takeLatest(
    checkoutActionTypes.CREATE_OR_UPDATE_CUSTOMER_CARD,
    createOrUpdateAddressCustomerCardRequest,
  ),
  takeLatest(
    checkoutActionTypes.SELECT_ADDRESS_CUSTOMER_CARD,
    selectedAddressCustomerCardRequest,
  ),
  takeLatest(
    checkoutActionTypes.UPDATE_CUSTOMER_CARD,
    updateCustomerCardRequest,
  ),
  takeLatest(
    checkoutActionTypes.REMOVE_ADDRESS_CUSTOMER_CARD,
    removeAddressCustomerCardRequest,
  ),
  takeLatest(checkoutActionTypes.APPLY_COUPON, applyCouponRequest),
  takeLatest(checkoutActionTypes.CHECK_PAYMENT_REQUEST, checkPaymentRequest),
]);
